// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdAdd, MdEvent } from 'react-icons/lib/md';
import i18n from 'i18n-js';
// import 'rc-collapse/assets/index.css';

import * as selectors from '../../reducers';
import * as studentActions from '../../actions/students';

// import OpenButton from '../OpenButton';
import User from '../User';
import Card from '../Card';
import CardHeader from '../CardHeader';
import CardContent from '../CardContent';
import CardHeaderRightGroup from '../CardHeaderRightGroup';
import CardHeaderTitleContainer from '../CardHeaderTitleContainer';
import Collapsable from '../Accordion/Collapsable';
import Panel from '../Accordion/Panel';
import { ReduxClickPopover } from '../Closeable';

import styles from './studentCard.css';
import StudentDataPanel from './StudentDataPanel/index';
import type { PARENT_TYPE } from '../../types/parents';
import type { STUDENT_TYPE } from '../../types/student';
import type { CHANGE_STOP_REQUEST_TYPE } from '../../types/changeStopRequest';
import type { ROUTE_STOP_TYPE } from '../../types/routes';
import ParentsPanel from './ParentsPanel';
import StopsPanel from './StopsPanel';
import ParentSearchPopover from '../ParentSearchPopover';
import { getUserImage } from '../../utils';
import StudentSchedulePopUp from '../StudentSchedulePopUp';
import * as closeableActions from '../../actions/closeable';

type StudentCardDummyPropTypes = {
  id: number,
  schoolId: ID_TYPE,
  addStudentParentStarted: Function,
  updateStudent: Function,
  parents: Array<PARENT_TYPE>,
  stops: Array<ROUTE_STOP_TYPE>,
  student: STUDENT_TYPE,
  changeRequests: Array<CHANGE_STOP_REQUEST_TYPE>,
  openStudentSchedule: Function,
};

const StudentCardDummy = ({
  // id,
  student = {},
  stops = [],
  parents = [],
  updateStudent,
  addStudentParentStarted,
  changeRequests,
  openStudentSchedule,
  ...props
}: StudentCardDummyPropTypes) => (
  <Fragment>
    <Card className={styles.studentCard} isRound {...props}>
      <CardHeader>
        <CardHeaderTitleContainer>
          <User
            firstName={student.first_name}
            lastName={student.last_name}
            userRole={i18n.t('labels.students', { count: 1 })}
            pictureURL={getUserImage(student.profile_picture)}
            useAsTitle
          />
        </CardHeaderTitleContainer>
        <CardHeaderRightGroup />
      </CardHeader>
      <CardContent clearPaddings>
        <Collapsable accordion>
          <Panel
            title={i18n.t('titles.personalInfo')}
            key="personalInfo"
          >
            <StudentDataPanel student={student} updateStudent={updateStudent} />
          </Panel>
          <Panel
            ActionComponent={
              () => (
                <ReduxClickPopover
                  isInline
                  id="addContactCard"
                  Content={ParentSearchPopover}
                  vertical="middle"
                  horizontal="after"
                  tipPosition="middle"
                  isRound="true"
                  onParentSelected={(element) => {
                    addStudentParentStarted(student.id, parseInt(element.id, 10));
                  }}
                >
                  <button type="actionButton">
                    <MdAdd size={30} />
                  </button>
                </ReduxClickPopover>
              )
            }
            title={i18n.t('titles.contacts')}
            key="contacts"
          >
            <ParentsPanel studentId={student.id} />
          </Panel>
          <Panel
            title={i18n.t('labels.route', { count: 2 })}
            badgeCount={changeRequests.length}
            ActionIcon={MdEvent}
            action={() => openStudentSchedule('stopsChedule')}
            key="1"
          >
            <StopsPanel studentId={student.id} />
          </Panel>
        </Collapsable>
      </CardContent>
      <StudentSchedulePopUp id="stopsChedule" />
    </Card>
  </Fragment>
);

const StudentCard = connect(
  (state, { id }) => {
    const student = selectors.getStudent(state, id);
    const changeRequests = selectors.getStudentChangeRequests(state, id);

    return {
      student,
      changeRequests,
    };
  },
  dispatch => ({
    updateStudent(student) {
      dispatch(studentActions.updateStudentStart({ ...student }));
    },
    openStudentSchedule(id) {
      dispatch(closeableActions.open(id));
    },
    addStudentParentStarted: (
      idStudent: number,
      idParent: number,
    ) => dispatch(studentActions.addStudentParentStarted(idStudent, idParent)),
  }),
  undefined,
)(StudentCardDummy);

export default StudentCard;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentCard/index.jsx